// Clock Panel
export var Clock = {
  name: "clock",
  component: "MultiDeviceClock",
  layout: "mdclock-root",
  mode: "visible",
  options: { disablePreMatch: true },
  showOn: [{ state: "clock.displayTime", value: null, operator: "not" }],
  actionGroups: [
    {
      actions: [
        // Set Main Entity
        {
          action: "saveData",
          value: ["hasArrow"],
          type: "variables",
        },
        {
          action: "setPossession",
          value: { currentEntity: true },
          type: "main",
        },
        {
          action: "setArrow",
          value: { currentEntity: false },
          type: "main",
        },
      ],
      conditions: [
        {
          item: "clock.clockStatus",
          value: "periodStarted",
          event: "main",
          operator: "is",
        },
      ],
    },
    {
      actions: [
        // Set Main Entity
        {
          action: "checkResets",
          value: true,
          type: "clock",
        },
      ],
      conditions: [
        {
          item: "period.periodStatus",
          value: "pending",
          event: "periodStatus",
          operator: "is",
        },
      ],
    },
  ],
};
